import {isJSON} from "@/utils/validate";

export default {
    state: {
        get menusActive() {
            return sessionStorage.getItem('menusActive') || ''
        },
        set menusActive(val) {
            sessionStorage.setItem('menusActive', val)
        },
        get menusActives() {
            const arrString = sessionStorage.getItem('menusActives')
            return isJSON(arrString) ? JSON.parse(arrString) : []
        },
        set menusActives(arr) {
            sessionStorage.setItem('menusActives', JSON.stringify(arr))
        }
    },
    mutations: {
        setMenusActive(state, path) {
            state.menusActive = path
        },
        setMenusActives(state, arr) {
            state.menusActives = arr
        },
    },
}